<template>
  <div class="im-dialog-info" v-if="dialog">
    <Group v-if="group" :data="group"/>
    <User v-if="user" :data="user"/>
  </div>
</template>

<script>
  import Group from './group/Group.vue';
  import User from './user/User.vue';

  export default {
    name: 'Info',
    components: {
      Group,
      User
    },
    data() {
      return {
        group: null,
        user: null,
      };
    },
    computed: {
      dialog() {
        const { dialog } = this.$store.state;
        this.init(dialog);
        return dialog;
      },
    },
    methods: {
      init(dialog){
        if (dialog) {
          dialog.group === null
            ? this.initUser(dialog)
            : this.initGroup(dialog)
          ;
        }
      },
      async initUser(dialog) {
        this.user = dialog.user;
        this.group = null;
      },
      initGroup(dialog) {
        this.group = { ...dialog };
        this.user = null;
      }
    }
  };
</script>

<style scoped>

</style>